var React = require('react');

function IconGoogle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 12.28h11.33c.1.6.2 1.2.2 2C23.5 21.13 18.9 26 12 26 5.36 26 0 20.64 0 14S5.36 2 12 2c3.23 0 5.95 1.2 8.05 3.14l-3.27 3.14c-.9-.86-2.45-1.86-4.78-1.86-4.1 0-7.44 3.4-7.44 7.58S7.9 21.58 12 21.58c4.75 0 6.53-3.4 6.8-5.17H12v-4.1z"}));
}

IconGoogle.displayName = "IconGoogle";

IconGoogle.defaultProps = {"width":"24","height":"28","viewBox":"0 0 24 28"};

module.exports = IconGoogle;

IconGoogle.default = IconGoogle;
